import { makeStyles } from "tss-react/mui";

export const useNWONProjectStepsSectionStyles = makeStyles()((theme) => ({
  stepsWrapper: {
    flexDirection: "column",
    rowGap: theme.spacing(10),
    [theme.breakpoints.only("xs")]: {
      rowGap: theme.spacing(7),
    },
  },
}));
